import React from 'react';
import _ from 'lodash';

import {
  ThirdPartyAccountSelectFieldDocument,
  useDeleteThirdPartyAccountMutation,
  useSaveThirdPartyAccountModalLazyQuery,
  useSaveThirdPartyAccountMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(accountId?: string) {
  const [fnQuery, tuple] = useSaveThirdPartyAccountModalLazyQuery({});

  React.useEffect(
    () => {
      if (accountId && accountId !== '*') {
        fnQuery({
          variables: {
            id: accountId
          }
        });
      }
    },
    [
      accountId,
      fnQuery
    ]
  );

  return React.useMemo(
    () => {
      const thirdPartyAccount = tuple.data?.thirdPartyAccount;
      const address = thirdPartyAccount?.address;
      const phone = address?.phone ?? '';
      const data: IData = {
        formState: {
          name: thirdPartyAccount?.name ?? '',
          accountNumber: thirdPartyAccount?.accountNumber ?? '',
          carrierType: thirdPartyAccount?.carrierType ?? '',
          attention: thirdPartyAccount?.attention ?? '',
          addressee: thirdPartyAccount?.addressee ?? '',
          phoneNumber: _.startsWith(phone, '+1') ? _.replace(phone, '+1', '') : (phone),
          street1: address?.street1 ?? '',
          street2: address?.street2 ?? '',
          street3: address?.street3 ?? '',
          city: address?.city ?? '',
          usState: address?.usState ?? '',
          postalCode: address?.postalCode ?? '',
          countryCode: address?.countryCode ?? ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}




export function useSaveThirdPartyAccount(accountId?: string) {
  const [fnMutate, tuple] = useSaveThirdPartyAccountMutation({
    refetchQueries: [
      {
        query: ThirdPartyAccountSelectFieldDocument,
        variables: {}
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            id: accountId === '*' || !accountId ? undefined : accountId,
            name: formState.name,
            accountNumber: formState.accountNumber,
            carrierType: formState.carrierType,
            attention: formState.attention,
            addressee: formState.addressee,
            address: {
              street1: formState.street1,
              street2: formState.street2,
              street3: formState.street3,
              city: formState.city,
              usState: _.toUpper(formState.usState),
              postalCode: formState.postalCode,

              company: '',
              countryCode: _.toUpper(formState.countryCode),
              phone: `+1${formState.phoneNumber}`
            }
          }

        }
      });
    },
    [
      accountId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}



export function useDeleteThirdPartyAccount(accountId?: string) {
  const [fnMutate, tuple] = useDeleteThirdPartyAccountMutation({
    refetchQueries: [
      {
        query: ThirdPartyAccountSelectFieldDocument,
        variables: {}
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    async () => {
      if (accountId && accountId !== '*') {
        await fnMutate({
          variables: {
            id: accountId
          }
        });
      }
    },
    [
      accountId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
